import React from "react";

const InputField = ({
  type = "text",
  className = "mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0",
  onChange,
  id,
  placeholder,
  errorMsg,
  name,
  register,
}) => {
  return (
    <React.Fragment>
      <input
        {...register(name)} // Directly use register to handle value
        onChange={(e) => {
          register(name).onChange(e); // react-hook-form handles the value
          onChange && onChange(e.target.value); // Optionally call additional onChange
        }}
        name={name ?? ""}
        id={id ?? ""}
        type={type}
        className={className}
        placeholder={placeholder ?? ""}
      />
      {errorMsg && <div className="text-red-500 my-2">{errorMsg}</div>}
    </React.Fragment>
  );
};

export default InputField;
